import React, { useEffect, useState } from "react";
import { array, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import FooterMenuGroup from "../../../molecules/FooterMenuGroup";

import { logoRenderer } from "../../../utils/react-utils";

import "./defaultFooter.m.css";

const DefaultFooterBase = ({
  publisherSettings,
  prothomaloMenuItems,
  pageType,
  publisherAttributes,
  socialLinks,
  currentPath,
  micrositesMenuItems,
  customSocialLinks,
}) => {
  const [authMenu, setAuthMenu] = useState({});

  const footerLogo = "চিরন্তন ১৯৭১";
  const footerBottom = prothomaloMenuItems.find((item) => item.title === "Footer Bottom");
  const footerBottomLinks = footerBottom && footerBottom.children.length > 0 ? footerBottom.children : null;
  const lastFooterBottomLinks =
    footerBottomLinks && footerBottomLinks.length > 0 ? footerBottomLinks[footerBottomLinks.length - 1] : null;

  const defaultMenuItems = (siteMenuItems) => {
    const menuItems =
      siteMenuItems && siteMenuItems.length ? siteMenuItems.find((item) => item.title === "footer") : null;
    setAuthMenu(menuItems);
  };

  useEffect(() => {
    if (global.location.origin.includes("auth")) {
      defaultMenuItems(prothomaloMenuItems);
    } else {
      defaultMenuItems(prothomaloMenuItems);
    }
  }, [micrositesMenuItems, currentPath]);

  return (
    <div styleName="footer">
      <div styleName={`row1 ${pageType === "home-page" ? "no-border" : ""}`} className="print-footer-row1">
        {authMenu && authMenu.children && authMenu.children.length > 0 ? (
          <div styleName="footer-links" className="print-footer-links">
            <div styleName="logo">
              {logoRenderer(footerLogo, currentPath)}
              <div styleName="footer-tag-content">
                একাত্তরের মহান মুক্তিযুদ্ধ পৌঁছাল ৫০ বছরে, এর সুবর্ণজয়ন্তীতে। এই অভূতপূর্ব বছরটিকে প্রথম আলো অর্থবহভাবে
                উদ্‌যাপন করছে। পাঠকের সামনে নানাভাবে উপস্থিত করছে এর তথ্য, স্মৃতি, আদর্শ ও স্বপ্ন। মার্চ থেকে
                ডিসেম্বরব্যাপী চলবে এ আয়োজন।
              </div>
              <div styleName={`row3 ${publisherAttributes.lang === "en" ? "eng-row3" : ""}`}>
                {lastFooterBottomLinks && (
                  <>
                    <div styleName="default-editor" className="print-default-editor">
                      {lastFooterBottomLinks["item-type"] === "placeholder" ? (
                        <span>{lastFooterBottomLinks.title}</span>
                      ) : (
                        <a href={lastFooterBottomLinks.completeUrl}>{lastFooterBottomLinks.title}</a>
                      )}
                    </div>
                  </>
                )}
                <div styleName="copyright">{publisherSettings.copyright || ""}</div>
              </div>
            </div>
            <div styleName="menu-group">
              <FooterMenuGroup
                links={authMenu.children.slice(0, 12)}
                language={publisherAttributes.lang}
                className={"footer-menu-group1"}
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  micrositesMenuItems: get(state, ["qt", "data", "navigationMenu", "menuItems"], []),
  publisherSettings: get(state, ["qt", "config", "publisher-settings"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  prothomaloMenuItems: get(state, ["qt", "data", "navigationMenu", "prothomaloMenuItems"], []),
  pageType: get(state, ["qt", "pageType"], ""),
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
  customSocialLinks: get(state, ["qt", "config", "custom-social-links"], {}),
});

DefaultFooterBase.propTypes = {
  publisherSettings: object,
  prothomaloMenuItems: array,
  pageType: string,
  publisherAttributes: object,
  socialLinks: object,
  currentPath: string,
  domainSlug: string,
  micrositesMenuItems: array,
  customSocialLinks: object,
};

export const DefaultFooter = connect(mapStateToProps)(DefaultFooterBase);
